import axios from "./axios-auth";

const getCustomerOrders = (data) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/getcustomerorders",
      params: {},
      data: data,
      method: "POST",
    })
      .then((resp) => {
        console.log(resp, "resp from getCustomerOrders api");
        resolve(resp);
      })
      .catch(() => {
        console.log("error from getCustomerOrders api");
      });
  });

const getStatusCodes = () =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/getstatuscodes",
      method: "GET",
    })
      .then((resp) => {
        console.log(resp, "from getStatusCodes api");
        resolve(resp);
      })
      .catch(() => {
        console.log("error fromgetStatusCodes api");
      });
  });

const getCustomerOrderStatus = () =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/getcustomerorderstatus",
      method: "GET",
    })
      .then((resp) => {
        console.log(resp, "from getCustomerOrderStatus api");
        resolve(resp);
      })
      .catch(() => {
        console.log("error from getCustomerOrderStatus api");
      });
  });

const getSavedSearches = () =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/getsavedsearches",
      method: "GET",
    })
      .then((resp) => {
        console.log(resp, "from getSavedSearches api");
        resolve(resp);
      })
      .catch(() => {
        console.log("error from getSavedSearches api");
      });
  });

const getClients = () =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/getclients",
      method: "GET",
    })
      .then((resp) => {
        console.log(resp, "resp from getAllClients api");
        if (resp.status !== 200) {
          throw new Error(resp.data.message);
        }
        resolve(resp.data);
      })
      .catch(() => {
        alert(err);
        console.log("error from api folder while calling axios");
      });
  });

const saveSearch = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/savesearch",
      method: "POST",
      data: payload,
    })
      .then((resp) => {
        console.log(resp, "resp from saveSearch api");
        if (resp.status !== 200) {
          throw new Error(resp.data.message);
        }
        resolve(resp.data);
      })
      .catch(() => {
        alert(err);
        console.log("error from api folder while calling axios");
      });
  });

export {
  getCustomerOrders,
  getStatusCodes,
  getCustomerOrderStatus,
  getSavedSearches,
  getClients,
  saveSearch,
};
